import { FC } from 'react'
import { Button, IconButton, IconButtonProps, Text } from '@chakra-ui/react'
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from '../chakraComponents/dialog'
import { LuTrash2 } from 'react-icons/lu'

interface DeleteButtonWithDialogProps {
  onDelete: () => void
  deletedObjectName: string
  buttonProps?: IconButtonProps
}

export const DeleteButtonWithDialog: FC<DeleteButtonWithDialogProps> = ({
  onDelete,
  deletedObjectName,
  buttonProps,
}) => {
  return (
    <DialogRoot role='alertdialog'>
      <DialogTrigger asChild>
        <IconButton size={'xl'} variant={'ghost'} {...buttonProps}>
          <LuTrash2 />
        </IconButton>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Are you sure?</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Text>
            This action cannot be undone. This will permanently delete{' '}
            {deletedObjectName}.
          </Text>
        </DialogBody>
        <DialogFooter>
          <DialogActionTrigger asChild>
            <Button variant='outline'>Cancel</Button>
          </DialogActionTrigger>
          <DialogActionTrigger asChild>
            <Button backgroundColor={'primary.4'} onClick={onDelete}>
              Delete
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  )
}
